import React from 'react';
import PropTypes from 'prop-types';

import {FormInline} from '../../../fragments/forms';
import Button from '../../../fragments/button';
import SelectControl from '../../../fragments/select-control';

import style from './style.css';


const RxList = [
  'None',
  'Unknown',
  'NNRTI+NRTI',
  'RTI+PI',
  'AZT+3TC+EFV',
  'AZT+3TC+NVP',
  'TDF+3TC+EFV',
  'TDF+FTC+EFV',
  'TDF+3TC+NVP',
  'TDF+FTC+NVP',
];

function build_options(option_list) {
  return option_list.map((value) => ({
    value: value,
    label: value
  }));
}

export default class UpdatePanel extends React.Component {

  static propTypes = {
    rawDataCollection: PropTypes.object.isRequired,
    onUpdateColumn: PropTypes.func.isRequired,
    onShowHideColumns: PropTypes.func.isRequired,
  };

  constructor() {
    super(...arguments);
    this.state = {
      rx: {
        options: build_options(RxList),
        prompt: 'Choose regimen',
        choice: '',
      },
      button: {
        text: 'Update'
      },
      weeks: {
        name: "weeks",
        disabled: true,
        type: "number",
        placeholder: "unknown",
        value: '',
        label: 'Duration(weeks): ',
        size: 12,
      },
    };
  }

  async handleChooseRx(e) {
    e.preventDefault();
    const {rx, weeks} = this.state;
    rx.choice = e.target.value;

    if (rx.choice && !['None', 'Unknown'].includes(rx.choice)) {
      weeks.disabled = false;
    } else {
      weeks.disabled = true;
    }
    this.setState({
      rx,
      weeks,
    });

    await this.handleUpdateColumn();
  }


  async handleInputWeeks(e) {
    e.preventDefault();
    const {weeks} = this.state;
    weeks.value = e.target.value;
    this.setState({weeks});

  }

  async handleUpdateColumn() {
    const {
      rx, weeks
    } = this.state;

    const {
      onUpdateColumn,
      onShowHideColumns,
    } = this.props;

    if (rx.choice !== '') {
      onUpdateColumn('drugs', rx.choice);
    }

    if (weeks.value) {
      onUpdateColumn('weeks', weeks.value);
      onUpdateColumn('durationUnknown', 'No');
      onShowHideColumns({
        show: ['weeks'],
        hide: ['durationUnknown']
      });
    } else {
      onUpdateColumn('weeks', '');
      onUpdateColumn('durationUnknown', 'Yes');
      onShowHideColumns({
        hide: ['weeks'],
        show: ['durationUnknown']
      });
    }

  }

  render() {

    const {rx, weeks, button} = this.state;

    return (
      <React.Fragment>
        <div>
          <FormInline dom="span">
            <SelectControl
             options={rx.options}
             value={rx.choice}
             prompt={rx.prompt}
             onChange={this.handleChooseRx.bind(this)} />
          </FormInline>
          <FormInline dom="span" className={style.weeks}>
            <label htmlFor={weeks.name}>{weeks.label}</label>
            <input
             disabled={weeks.disabled}
             name={weeks.name}
             value={weeks.value}
             size={weeks.size}
             placeholder={weeks.placeholder}
             type={weeks.type}
             onChange={
               this.handleInputWeeks.bind(this)}
              />
          </FormInline>
          <FormInline dom="span">
            <Button
             btnStyle="primary"
             onClick={this.handleUpdateColumn.bind(this)}>
              {button.text}
            </Button>
          </FormInline>
        </div>
        <hr/>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/gtable/update-panel.js